import qrcode from 'qrcode-generator';

export interface QrMatrix {
  size: number;
  modules: boolean[][];
}

const cache = new Map<string, QrMatrix>();

/**
 * The card carries a QR to the assessment itself, not to a result. Keeping the
 * payload to the site entry URL holds the symbol at a low module count, which
 * is what makes it scannable from a compressed social image.
 */
export function qrMatrix(payload: string): QrMatrix {
  const cached = cache.get(payload);
  if (cached) return cached;

  const code = qrcode(0, 'M');
  code.addData(payload);
  code.make();

  const size = code.getModuleCount();
  const modules: boolean[][] = [];
  for (let row = 0; row < size; row += 1) {
    const line: boolean[] = [];
    for (let column = 0; column < size; column += 1) line.push(code.isDark(row, column));
    modules.push(line);
  }

  const matrix = { size, modules };
  cache.set(payload, matrix);
  return matrix;
}

/** The site entry, with any result parameters stripped. */
export function siteEntryUrl(href: string): string {
  try {
    const url = new URL(href);
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch {
    return href;
  }
}
